export default __webpack_public_path__ + "f73fb415d769a764df3f466d8255b0d5.svg";